import API from '@/services/api'

export default async function getPointByToken(terminalToken) {
  try {
    const response = await API.get(`points/${terminalToken}/name`)
    if (response?.data?.id) {
      sessionStorage.setItem('point_id_token_selection', response?.data?.id)
    }
    return response.data
  } catch (error) {
    console.error(error)
    return null
  }
}
